import _ from "lodash";

function pastXMothsSuicidalIdeation(studyId) {
  switch (studyId) {
    case "9a29876b-365a-4bd3-a0d0-bdf05a5c042c":
      return 6; // DEV (For Testing of TUR-155332)
    case "5ee53d4a-dab3-4510-aca3-0f2e3cd31773":
      return 6; // STAGE (For Testing of TUR-155332)
    case "e16bb221-be6b-454e-a3b5-4f845242589a":
      return 6; // UAT (For Testing of TUR-155332)
    case "7c806f78-0b96-49c1-a392-6afe918c8412":
      return 6; // Sanofi Instance (For HS Obtain of TUR-155332)
    case "b6ef452a-9d2d-4ebc-8c3a-53246973c4b1":
      return 6; // Sanofi-UAT Instance (For Mock Study of TUR-155332)
    default:
      return "X";
  }
}
function replacePastXMonthsString(activityData, studyId) {
  if (activityData) {
    const newResponseJSON = JSON.stringify(activityData).replaceAll("Past X Months", `Past ${pastXMothsSuicidalIdeation(studyId)} Months`); //convert to JSON string
    return JSON.parse(newResponseJSON);
  }
}

export function getActivityStructure(activityDataOld, studyId = null) {
  let activityData = activityDataOld;
  if (activityData) {
    activityData = replacePastXMonthsString(activityData, studyId);
    let rows = _.cloneDeep(activityData.rows ? activityData.rows : []);
    let allQuestions = _.cloneDeep(activityData.questions);
    let secArray = allQuestions.filter(o => o.type == "Section");
    let questions = allQuestions.filter(o => o.type != "Section");

    if (rows.length > 0) {
      let rowObj = [];
      let stepIndex = 1;
      rows.forEach((e, i) => {
        if (e.length > 1) {
          let colObj = [];
          e.forEach((ie, ii) => {
            let question = questions.find(o => o.id == ie);
            if (question !== undefined) {
              question["stepSequence"] = stepIndex;
              colObj[ii] = question;

              stepIndex++;
            }
          });
          rowObj[i] = colObj.filter(o => true);
        } else {
          let question = questions.find(o => o.id == e);
          if (question !== undefined) {
            question["stepSequence"] = stepIndex;
            rowObj[i] = [question];

            stepIndex++;
          }
        }
      });

      if (secArray.length > 0) {
        secArray.forEach(section => {
          let rowFinalIndex = null;
          rowObj.forEach((questions, index) => {
            let rowIndex = questions.findIndex(o => o.id == section.nextQuestionId);
            //console.log(index, rowIndex, section.nextQuestionId);
            if (rowIndex > -1) {
              rowFinalIndex = index;
            }
          });
          ///rowFinalIndex   = (rowFinalIndex > 0) ? rowFinalIndex - 1 : rowFinalIndex;
          rowObj.splice(rowFinalIndex, 0, [section]);
        });
        return rowObj.filter(o => true);
      } else {
        return rowObj.filter(o => true);
      }
    } else {
      let rowObj = [];
      allQuestions.forEach(q => {
        rowObj.push([q]);
      });
      return rowObj;
    }
  } else {
    return [];
  }
}

export function isAnswer(question) {
  if (question.answerId) {
    return true;
  } else if (question.answer) {
    return true;
  } else if (question.date) {
    return true;
  } else {
    return false;
  }
}

export function hasFieldErrorFun(question) {
  if (!isAnswer(question)) {
    question.hasFieldError = true;
  } else {
    question.hasFieldError = false;
  }
}

export function validateQuestionAnswer(question) {
  if (question.answerId) {
    if (question.answerId === question.options[0].id) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

// Since last visit CSSR validation
export function checkValidationConfiguration(activityData) {
  const sinceLastVisitQuestions = activityData.questions;
  if (sinceLastVisitQuestions) {
    //1
    let wishToBeDeadQuestion = sinceLastVisitQuestions[2];
    hasFieldErrorFun(wishToBeDeadQuestion);
    //2
    let nonSpecificQuestion = sinceLastVisitQuestions[4];
    hasFieldErrorFun(nonSpecificQuestion);

    if ((validateQuestionAnswer(wishToBeDeadQuestion) && validateQuestionAnswer(nonSpecificQuestion)) || (!validateQuestionAnswer(wishToBeDeadQuestion) && validateQuestionAnswer(nonSpecificQuestion))) {
      //3
      let activeSuicidal = sinceLastVisitQuestions[6];
      hasFieldErrorFun(activeSuicidal);
      //4
      let specificPlanQuestion = sinceLastVisitQuestions[8];
      hasFieldErrorFun(specificPlanQuestion);
      //5
      let specificIntentQuestion = sinceLastVisitQuestions[10];
      hasFieldErrorFun(specificIntentQuestion);
    }
    // INTENSITY OF IDEATION
    if ((validateQuestionAnswer(wishToBeDeadQuestion) && validateQuestionAnswer(nonSpecificQuestion)) || (!validateQuestionAnswer(wishToBeDeadQuestion) && validateQuestionAnswer(nonSpecificQuestion)) || (validateQuestionAnswer(wishToBeDeadQuestion) && !validateQuestionAnswer(nonSpecificQuestion))) {
      hasFieldErrorFun(sinceLastVisitQuestions[15]);
      hasFieldErrorFun(sinceLastVisitQuestions[16]);
      hasFieldErrorFun(sinceLastVisitQuestions[17]);
      hasFieldErrorFun(sinceLastVisitQuestions[18]);
      hasFieldErrorFun(sinceLastVisitQuestions[19]);
    }

    // SUICIDAL BEHAVIOR
    let actualAttemptQuestion = sinceLastVisitQuestions[21];
    hasFieldErrorFun(actualAttemptQuestion);
    if (actualAttemptQuestion && validateQuestionAnswer(actualAttemptQuestion)) {
      hasFieldErrorFun(sinceLastVisitQuestions[23]);
      hasFieldErrorFun(sinceLastVisitQuestions[36]);
      let medicalDamage = sinceLastVisitQuestions[37];
      hasFieldErrorFun(medicalDamage);
      if (medicalDamage.answer == "0") {
        hasFieldErrorFun(sinceLastVisitQuestions[38]);
      } else {
        sinceLastVisitQuestions[38].hasFieldError = false;
      }
    }
    // if Actual Lethality 0 then Potential Lethality req
    let medicalDamage = sinceLastVisitQuestions[37];
    if (medicalDamage.answer == "0") {
      hasFieldErrorFun(sinceLastVisitQuestions[38]);
    } else {
      sinceLastVisitQuestions[38].hasFieldError = false;
    }

    //Has subject engaged
    hasFieldErrorFun(sinceLastVisitQuestions[24]);

    // Interrupted Attempt
    let interruptedAttemptQuestion = sinceLastVisitQuestions[25];
    hasFieldErrorFun(interruptedAttemptQuestion);
    if (validateQuestionAnswer(interruptedAttemptQuestion)) {
      hasFieldErrorFun(sinceLastVisitQuestions[27]);
    }
    // Aborted Attempt
    let abortedAttemptQuestion = sinceLastVisitQuestions[28];
    hasFieldErrorFun(abortedAttemptQuestion);
    if (validateQuestionAnswer(abortedAttemptQuestion)) {
      hasFieldErrorFun(sinceLastVisitQuestions[30]);
    }

    // Preparatory Acts or Behavior
    hasFieldErrorFun(sinceLastVisitQuestions[31]);

    // Suicidal Behavior
    let SuicidalBehaviorQuestion = sinceLastVisitQuestions[33];
    hasFieldErrorFun(SuicidalBehaviorQuestion);
    if (validateQuestionAnswer(SuicidalBehaviorQuestion)) {
      //Complete Suicidal
      sinceLastVisitQuestions[34].hasFieldError = false;
    } else {
      hasFieldErrorFun(sinceLastVisitQuestions[34]);
    }

    return activityData;
  }
}

export function interruptedAttemptValidation(activityQuestions) {
  let interruptedAttempt = activityQuestions[40];
  let interruptedAttemptRecency = activityQuestions[41];
  let interruptedAttemptTotalAttempt = activityQuestions[43];
  let interruptedAttemptTotalAttemptRecency = activityQuestions[44];
  hasFieldErrorFun(interruptedAttempt);
  //Lifetime total
  if (validateQuestionAnswer(interruptedAttempt) && !isAnswer(interruptedAttemptTotalAttempt)) {
    interruptedAttemptTotalAttempt.hasFieldError = true;
  } else {
    interruptedAttemptTotalAttempt.hasFieldError = false;
  }
  // receacy boolean
  if (validateQuestionAnswer(interruptedAttempt) && !isAnswer(interruptedAttemptRecency)) {
    interruptedAttemptRecency.hasFieldError = true;
  } else {
    interruptedAttemptRecency.hasFieldError = false;
  }

  // receacy total attempt
  if (validateQuestionAnswer(interruptedAttemptRecency) && !isAnswer(interruptedAttemptTotalAttemptRecency)) {
    interruptedAttemptTotalAttemptRecency.hasFieldError = true;
  } else {
    interruptedAttemptTotalAttemptRecency.hasFieldError = false;
  }
}

export function abortedAttemptValidation(activityQuestions) {
  let interruptedAttempt = activityQuestions[45];
  let interruptedAttemptRecency = activityQuestions[46];
  let interruptedAttemptTotalAttempt = activityQuestions[48];
  let interruptedAttemptTotalAttemptRecency = activityQuestions[49];
  hasFieldErrorFun(interruptedAttempt);
  //Lifetime total
  if (validateQuestionAnswer(interruptedAttempt) && !isAnswer(interruptedAttemptTotalAttempt)) {
    interruptedAttemptTotalAttempt.hasFieldError = true;
  } else {
    interruptedAttemptTotalAttempt.hasFieldError = false;
  }
  // receacy boolean
  if (validateQuestionAnswer(interruptedAttempt) && !isAnswer(interruptedAttemptRecency)) {
    interruptedAttemptRecency.hasFieldError = true;
  } else {
    interruptedAttemptRecency.hasFieldError = false;
  }

  // receacy total attempt
  if (validateQuestionAnswer(interruptedAttemptRecency) && !isAnswer(interruptedAttemptTotalAttemptRecency)) {
    interruptedAttemptTotalAttemptRecency.hasFieldError = true;
  } else {
    interruptedAttemptTotalAttemptRecency.hasFieldError = false;
  }
}

export function preparatoryAttemptValidation(activityQuestions) {
  let interruptedAttempt = activityQuestions[50];
  let interruptedAttemptRecency = activityQuestions[51];

  hasFieldErrorFun(interruptedAttempt);
  // receacy boolean
  if (validateQuestionAnswer(interruptedAttempt) && !isAnswer(interruptedAttemptRecency)) {
    interruptedAttemptRecency.hasFieldError = true;
  } else {
    interruptedAttemptRecency.hasFieldError = false;
  }
}

export function baselineSuicidalBehaviorValidation(activityQuestions) {
  let interruptedAttempt = activityQuestions[53];
  let interruptedAttemptRecency = activityQuestions[54];

  hasFieldErrorFun(interruptedAttempt);
  // receacy boolean
  if (validateQuestionAnswer(interruptedAttempt) && !isAnswer(interruptedAttemptRecency)) {
    interruptedAttemptRecency.hasFieldError = true;
  } else {
    interruptedAttemptRecency.hasFieldError = false;
  }
}

// Baseline validation
export function checkBaselineValidationConfiguration(activityData) {
  const activityQuestions = activityData.questions;
  if (activityQuestions) {
    // 1
    let wishToBeDeadQuestion = activityQuestions[2];
    let wishToBeDeadRecency = activityQuestions[3];
    if (!isAnswer(wishToBeDeadQuestion)) {
      wishToBeDeadQuestion.hasFieldError = true;
    } else {
      wishToBeDeadQuestion.hasFieldError = false;
    }
    if (validateQuestionAnswer(wishToBeDeadQuestion) && !isAnswer(wishToBeDeadRecency)) {
      wishToBeDeadRecency.hasFieldError = true;
    } else {
      wishToBeDeadRecency.hasFieldError = false;
    }

    //2
    let nonSpecificQuestion = activityQuestions[5];
    let nonSpecificRecency = activityQuestions[6];
    if (!isAnswer(nonSpecificQuestion)) {
      nonSpecificQuestion.hasFieldError = true;
    } else {
      nonSpecificQuestion.hasFieldError = false;
    }
    if (validateQuestionAnswer(nonSpecificQuestion) && !isAnswer(nonSpecificRecency)) {
      nonSpecificRecency.hasFieldError = true;
    } else {
      nonSpecificRecency.hasFieldError = false;
    }

    if ((validateQuestionAnswer(wishToBeDeadQuestion) && validateQuestionAnswer(nonSpecificQuestion)) || (!validateQuestionAnswer(wishToBeDeadQuestion) && validateQuestionAnswer(nonSpecificQuestion))) {
      // 3
      let activeSuicidal = activityQuestions[8];
      let activeSuicidalRecency = activityQuestions[9];
      if (!isAnswer(activeSuicidal)) {
        activeSuicidal.hasFieldError = true;
      } else {
        activeSuicidal.hasFieldError = false;
      }
      if (validateQuestionAnswer(activeSuicidal) && !isAnswer(activeSuicidalRecency)) {
        activeSuicidalRecency.hasFieldError = true;
      } else {
        activeSuicidalRecency.hasFieldError = false;
      }

      //4
      let specificPlanQuestion = activityQuestions[11];
      let specificPlanRecency = activityQuestions[12];
      if (!isAnswer(specificPlanQuestion)) {
        specificPlanQuestion.hasFieldError = true;
      } else {
        specificPlanQuestion.hasFieldError = false;
      }
      if (validateQuestionAnswer(specificPlanQuestion) && !isAnswer(specificPlanRecency)) {
        specificPlanRecency.hasFieldError = true;
      } else {
        specificPlanRecency.hasFieldError = false;
      }

      //5
      let specificIntentQuestion = activityQuestions[14];
      let specificIntentRecency = activityQuestions[15];
      if (!isAnswer(specificIntentQuestion)) {
        specificIntentQuestion.hasFieldError = true;
      } else {
        specificIntentQuestion.hasFieldError = false;
      }
      if (validateQuestionAnswer(specificIntentQuestion) && !isAnswer(specificIntentRecency)) {
        specificIntentRecency.hasFieldError = true;
      } else {
        specificIntentRecency.hasFieldError = false;
      }
    }
    // INTENSITY OF IDEATION
    if ((validateQuestionAnswer(wishToBeDeadQuestion) && validateQuestionAnswer(nonSpecificQuestion)) || (!validateQuestionAnswer(wishToBeDeadQuestion) && validateQuestionAnswer(nonSpecificQuestion)) || (validateQuestionAnswer(wishToBeDeadQuestion) && !validateQuestionAnswer(nonSpecificQuestion))) {
      hasFieldErrorFun(activityQuestions[22]);
      hasFieldErrorFun(activityQuestions[24]);
      hasFieldErrorFun(activityQuestions[26]);
      hasFieldErrorFun(activityQuestions[28]);
      hasFieldErrorFun(activityQuestions[30]);
    }
    // Recency
    if (validateQuestionAnswer(wishToBeDeadRecency) || validateQuestionAnswer(nonSpecificRecency)) {
      hasFieldErrorFun(activityQuestions[23]);
      hasFieldErrorFun(activityQuestions[25]);
      hasFieldErrorFun(activityQuestions[27]);
      hasFieldErrorFun(activityQuestions[29]);
      hasFieldErrorFun(activityQuestions[31]);
    }

    // Sucidal behaviour
    let actualAttemptQuestion = activityQuestions[33];
    hasFieldErrorFun(actualAttemptQuestion);

    if (actualAttemptQuestion && validateQuestionAnswer(actualAttemptQuestion)) {
      //Actual Attempt (Recency)
      let actualAttemptRecency = activityQuestions[34];
      let totalAttemptsRecency = activityQuestions[37];
      if (validateQuestionAnswer(actualAttemptQuestion) && !isAnswer(actualAttemptRecency)) {
        actualAttemptRecency.hasFieldError = true;
      } else {
        actualAttemptRecency.hasFieldError = false;
      }
      // Recency total attempt
      if (validateQuestionAnswer(actualAttemptRecency) && !isAnswer(totalAttemptsRecency)) {
        totalAttemptsRecency.hasFieldError = true;
      } else {
        totalAttemptsRecency.hasFieldError = false;
      }

      //total actual attempts lifetime
      let totalAttemptsLifeTime = activityQuestions[36];
      hasFieldErrorFun(totalAttemptsLifeTime);

      //Date
      let mostRecentAttempt = activityQuestions[56];
      let mostLethalAttempt = activityQuestions[57];
      let initialAttempt = activityQuestions[58];
      hasFieldErrorFun(mostRecentAttempt);
      hasFieldErrorFun(mostLethalAttempt);
      hasFieldErrorFun(initialAttempt);

      // Actual Lethality/Medical Damage:
      let isRecentAttempt = activityQuestions[59];
      hasFieldErrorFun(isRecentAttempt);
      if (isRecentAttempt.answer == "0") {
        // Potential Lethality: Only Answer if Actual Lethality=0 (Recent)
        hasFieldErrorFun(activityQuestions[62]);
      } else {
        activityQuestions[62].hasFieldError = false;
      }

      let isLethalAttempt = activityQuestions[60];
      hasFieldErrorFun(isLethalAttempt);
      if (isLethalAttempt.answer == "0") {
        // Potential Lethality: Only Answer if Actual Lethality=0 (Lethal)
        hasFieldErrorFun(activityQuestions[63]);
      } else {
        activityQuestions[63].hasFieldError = false;
      }

      let isFirstAttempt = activityQuestions[61];
      hasFieldErrorFun(isFirstAttempt);
      if (isFirstAttempt.answer == "0") {
        // Potential Lethality: Only Answer if Actual Lethality=0 (First)
        hasFieldErrorFun(activityQuestions[64]);
      } else {
        activityQuestions[64].hasFieldError = false;
      }
    } else {
      activityQuestions[34].hasFieldError = false;
      activityQuestions[36].hasFieldError = false;
      activityQuestions[37].hasFieldError = false;
      activityQuestions[56].hasFieldError = false;
      activityQuestions[57].hasFieldError = false;
      activityQuestions[58].hasFieldError = false;
      activityQuestions[59].hasFieldError = false;
      activityQuestions[60].hasFieldError = false;
      activityQuestions[61].hasFieldError = false;
    }

    // if Actual Lethality/Medical Damage then Potential Lethality required

    // Potential Lethality: Only Answer if Actual Lethality=0 (Recent)
    if (activityQuestions[59] && activityQuestions[59].answer == "0") {
      hasFieldErrorFun(activityQuestions[62]);
    } else {
      activityQuestions[62].hasFieldError = false;
    }

    // Potential Lethality: Only Answer if Actual Lethality=0 (Lethal)
    if (activityQuestions[60] && activityQuestions[60].answer == "0") {
      hasFieldErrorFun(activityQuestions[63]);
    } else {
      activityQuestions[63].hasFieldError = false;
    }

    // Potential Lethality: Only Answer if Actual Lethality=0 (First)
    if (activityQuestions[61].answer == "0") {
      hasFieldErrorFun(activityQuestions[64]);
    } else {
      activityQuestions[64].hasFieldError = false;
    }

    // Has subject engaged
    hasFieldErrorFun(activityQuestions[38]);
    hasFieldErrorFun(activityQuestions[39]);

    // Interrupted Attempt
    interruptedAttemptValidation(activityQuestions);

    // Aborted Attempt
    abortedAttemptValidation(activityQuestions);

    // Preparatory Acts or Behavior
    preparatoryAttemptValidation(activityQuestions);

    // Suicidal Behavior
    baselineSuicidalBehaviorValidation(activityQuestions);
    return activityData;
  }
}

// since last visit keys
export const WISH_TO_BE_DEAD_SINCE_LAST_VISIT = 2;
export const NON_SPECIFIC_ACTIVE_SLV = 3;
export const SLV_ACTIVE_SUICIDAL_NO_PLAN = 4;
export const SLV_INTENT_TO_ACT = 5;
export const SLV_ACTIVE_SUICIDAL_SPECIFIC_PLAN = 6;
export const ACTUAL_ATTEMPT_SLV = 15;
export const SLV_INTERRUPTED_ATTEMPTS = 16;
export const SLV_ABORTED_ATTEMPT = 17;
export const SLV_PREPARATORY_ACTS = 18;
export const SLV_ACTUAL_ATTEMPT_DATE = 21;
export const SLV_ACTUAL_LETHALITY = 22;
export const SLV_ACTUAL_POTENTIAL_LETHALITY = 23;

// Baseline
export const WISH_TO_BE_DEAD_BASELINE = 2;
export const NON_SPECIFIC_ACTIVE_BASELINE = 3;
export const ACTIVE_SUICIDAL_NO_PLAN_BASELINE = 4;
export const INTENT_TO_ACT_BASELINE = 5;
export const ACTIVE_SUICIDAL_SPECIFIC_PLAN_BASELINE = 6;
export const MOST_SERVERE_IDEATION = 8;
export const FREQUENCY = 9;
export const DUARATION = 10;
export const CONTROLLABILTY = 11;
export const DETERRENTS = 12;
export const REASONS_FOR_IDEATION = 13;
export const ACTUAL_ATTEMPT_BASELINE = 15;
export const INTERRUPTED_ATTEMPTS_BASELINE = 16;
export const ABORTED_ATTEMPT_BASELINE = 17;
export const PREPARATORY_ACTS_BASELINE = 18;
export const LIFETIME_SUICIDAL_BEHAVIOR_BASELINE = 19;
export const ACTUAL_ATTEMPT_DATE_BASELINE = 20;
export const ACTUAL_LETHALITY_BASELINE = 21;
export const POTENTIAL_LETHALITY_BSELINE = 22;
